import { render } from "./Index.vue?vue&type=template&id=3ba96f58&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3ba96f58"

export default script